<template>
  <div>
    <PaymentForm 
      v-if="!payment"
      :paymentProductName="paymentDescription()" 
      :paymentProductValue="paymentValue()"
      :paymentProductOwnerIdentification="user.cnpj"
      @doPayment="processPayment" 
    />

    <OrderPaymentInfoSuccess v-if="payment" :payment="payment" />

    <v-btn depressed color="secondary" @click.prevent="goToOrder()" class="mt-5">
      Acessar Pedido
    </v-btn>
  </div> 
</template>

<script>
import PaymentService from '@/services/pagamento.service';
import PaymentForm from '@/components/Payment/PaymentForm.vue';
import OrderPaymentInfoSuccess from './OrderPaymentInfoSuccess.vue';
import { mapState } from "vuex";

export default {
  name: "OrderPaymentForm",
  
  components: {
    PaymentForm,
    OrderPaymentInfoSuccess
  },
  
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  
  data: () => ({
    payments: [],

    payment: null
  }),

  mounted() {    
    this.fetchPayments(this.order.id);
  },
  
  computed: {
    ...mapState("global", ["user"]),
  },
  
  methods: {
    fetchPayments(order_id) {
      if (!order_id) return;

      PaymentService
        .list({input: { order_id: order_id }})
        .subscribe({
          next: ({items}) => {            
            this.payments = items;
          }
      });
    },

    paymentDescription() {
      return `${this.payments[0].description}`;
    },

    paymentValue() {
      return parseFloat(this.payments[0].value.raw);
    },  

    goToOrder() {
      this.$router.push({ name: 'orders-detail', params: { id: this.order.id} });
    },

    processPayment(event) {      
      PaymentService
        .process(this.payments[0].id, event)
        .subscribe({
          next: ({id}) => {            
            this.$emit('doPayment', {...event, id});
            this.fetchPayment(id)
          }
        });
    },

    fetchPayment(payment_id) { 
      if (!payment_id) return;     
      
      PaymentService
        .show(payment_id)
        .subscribe({
          next: (data) => {            
            this.payment = data;                        
          }
      });    
    }
  }
};
</script>
